/*
  We want to override default ISO string outputs since axios/network layer
  would internally call toISOString() against date/moment instances.
  That way we pass a proper string to backend.
*/
const _toISOString = Date.prototype.toISOString;
// eslint-disable-next-line no-extend-native
Date.prototype.toISOString = function() {
  return _toISOString
    .call(new Date(this.valueOf() - this.getTimezoneOffset() * 60000))
    .slice(0, -1);
};
